// extracted by mini-css-extract-plugin
var _1 = "RequestProfileWidgetSendNotificationField-modulecheckboxLabel__eVR5J";
var _2 = "RequestProfileWidgetSendNotificationField-modulecheckboxLabelTitle__w7iZF";
export { _1 as "checkboxLabel", _2 as "checkboxLabelTitle" }
